import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddVendorModalPage } from './add-vendor-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AddVendorModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddVendorModalPage]
})
export class AddVendorModalPageModule {}
